module.exports = __webpack_public_path__ + "img/status_use.57e6f33e.png";